// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .no-data {
      padding: 20px;
      text-align: center;
      font-style: italic;
    }
    .error-message {
      padding: 20px;
      text-align: center;
      color: #f44336;
      font-weight: bold;
    }
    table {
      width: 100%;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/analytics/sales-details-dialog.component.ts"],"names":[],"mappings":";IACI;MACE,aAAa;MACb,kBAAkB;MAClB,kBAAkB;IACpB;IACA;MACE,aAAa;MACb,kBAAkB;MAClB,cAAc;MACd,iBAAiB;IACnB;IACA;MACE,WAAW;IACb","sourcesContent":["\n    .no-data {\n      padding: 20px;\n      text-align: center;\n      font-style: italic;\n    }\n    .error-message {\n      padding: 20px;\n      text-align: center;\n      color: #f44336;\n      font-weight: bold;\n    }\n    table {\n      width: 100%;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
